import React, { useState } from 'react';
import ExportIcon from './ExportIcon';
import Tooltip from './Tooltip';
import Button from './Button';

const ExportButton = ({ exportOptions, onExport }) => {
  const [showMenu, setShowMenu] = useState(false);

  const toggleMenu = () => setShowMenu((prev) => !prev);
  const handleExportClick = (format) => {
    onExport(format);
    setShowMenu(false);
  };

  return (
    <div className="relative inline-block">
      <Tooltip text="Export data" variant="secondary">
        <Button
          variant="light"
          className="px-[10px] py-[7px]"
          onClick={toggleMenu}
          ariaLabel="Export data"
        >
          <ExportIcon />
        </Button>
      </Tooltip>
      {showMenu && (
        <div className="absolute right-0 mt-2 w-32 bg-white rounded-md shadow-lg z-10 overflow-hidden">
          {exportOptions.map((option) => (
            <button
              key={option.format}
              onClick={() => handleExportClick(option.format)}
              className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
            >
              {option.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default ExportButton;
